// services/authService.js
import CryptoJS from 'crypto-js';

// Clé de chiffrement (en production, cette clé devrait être plus complexe)
const ENCRYPTION_KEY = 'AFDT-SUIVIMED-2025-KEY';

// Identifiants chiffrés
const ENCRYPTED_CREDENTIALS = {
  username: CryptoJS.AES.encrypt('afdtmedecin@afdt-suivimed', ENCRYPTION_KEY).toString(),
  password: CryptoJS.AES.encrypt('TAchott@2025', ENCRYPTION_KEY).toString()
};

// Fonction pour déchiffrer
const decrypt = (encryptedText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Erreur de déchiffrement:', error);
    return null;
  }
};

// Fonction d'authentification
export const authenticateUser = (username, password) => {
  try {
    const decryptedUsername = decrypt(ENCRYPTED_CREDENTIALS.username);
    const decryptedPassword = decrypt(ENCRYPTED_CREDENTIALS.password);
    
    if (!decryptedUsername || !decryptedPassword) {
      return { success: false, message: 'Erreur de configuration' };
    }
    
    if (username === decryptedUsername && password === decryptedPassword) {
      // Stocker l'état de connexion
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('authenticatedUser', username);
      localStorage.setItem('loginTime', new Date().toISOString());
      
      return { success: true, message: 'Connexion réussie' };
    } else {
      return { success: false, message: 'Identifiants incorrects' };
    }
  } catch (error) {
    console.error('Erreur d\'authentification:', error);
    return { success: false, message: 'Erreur lors de l\'authentification' };
  }
};

// Fonction pour vérifier si l'utilisateur est connecté
export const isAuthenticated = () => {
  return localStorage.getItem('isAuthenticated') === 'true';
};

// Fonction pour déconnecter
export const logout = () => {
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('authenticatedUser');
  localStorage.removeItem('loginTime');
};

// Fonction pour obtenir l'utilisateur connecté
export const getAuthenticatedUser = () => {
  return localStorage.getItem('authenticatedUser');
};
